// pages/Dashboard.jsx
import PickupDeliveryPolicy from "../../components/home/policyComponents/PickupDeliveryPolicy";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <PickupDeliveryPolicy />
    </HomeLayout>
  );
}
